import { watch } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import useOpen from '../../../composables/useOpen';
import { useScrollLock } from '../../../composables/useScrollLock';
import useSuggestQuery from './useSuggestQuery';

export default function useSuggest() {
  const { open, setOpen } = useOpen(false);
  const { query, term } = useSuggestQuery();

  useScrollLock(open);
  watch(query.data, () => !open.value && setOpen(true));

  const suggest = useDebounceFn((input) => {
    term.value = input;
    return input ? query.refetch() : setOpen(false);
  }, 300);

  return {
    ...query, suggest, open, setOpen, term,
  };
}
